module.exports = __webpack_public_path__ + "static/media/Left pawn bottom.ef84c14c.svg";